import type { AuthorizedResource } from '@/services/bff/permission.api';

export type AuthorizedResourceAccessMap = Record<string, boolean>;

export const isAuthorizedResourceAllowed = (effect?: string | null) =>
  effect === 'ALLOW';

export function buildAuthorizedResourceAccessMap(
  authorizedResources: AuthorizedResource[] = [],
): AuthorizedResourceAccessMap {
  return authorizedResources.reduce<AuthorizedResourceAccessMap>(
    (accumulator, resource) => {
      if (!resource?.code) {
        return accumulator;
      }

      const allowed = isAuthorizedResourceAllowed(resource.effect);

      accumulator[resource.code] = allowed;

      (resource.actions ?? []).forEach((action) => {
        const actionName = typeof action === 'string' ? action : action?.name;
        if (actionName) {
          accumulator[`${resource.code}:${actionName}`] = allowed;
        }
      });

      return accumulator;
    },
    {},
  );
}
